import React from "react";
import Button from "../ui/Button";
import { getImpersonationState } from "../../lib/authSession";
import { useTranslation } from "../../i18n";

const ImpersonationBanner = ({ onEndImpersonation, ending }) => {
  const { t } = useTranslation();
  const state = getImpersonationState();
  if (!state) return null;

  const targetLabel =
    state.target?.full_name || state.target?.email || t("common.user");
  const adminLabel = state.admin?.full_name || state.admin?.email || t("common.admin");

  return (
    <div
      className="sticky top-0 z-50 border-b border-amber-300 bg-amber-50 px-4 py-2.5"
      role="status"
    >
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3">
        <p className="text-[13px] font-medium text-amber-950">
          {t("impersonation.actingAs", {
            target: targetLabel,
            email: state.target?.email,
            admin: adminLabel,
          })}
        </p>
        <Button
          type="button"
          variant="teal"
          className="!h-9 !w-auto !rounded-full !px-4 !text-[12px]"
          disabled={ending}
          onClick={onEndImpersonation}
        >
          {ending ? t("impersonation.ending") : t("impersonation.backToAdmin")}
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
